// @ts-check

/**
 * Used to filter the fields to import based on the identifier fields.
 * This is needed because we define 2 different identifiers: 'product.instanceId' and 'product.productExternalId'.
 * @param {Object} props
 * @param {Object[]} props.identifierFields
 * @param {Object[]} props.fieldsToImport
 * @returns
 */
export function filterFieldsToImport({ identifierFields, fieldsToImport }) {
  const _isUsingExternalId = isUsingExternalId(identifierFields);
  const _isUsingProductId = isUsingProductId(identifierFields);

  return fieldsToImport.filter(({ key }) => {
    if (key === 'product.productExternalId' && !_isUsingExternalId) {
      return false;
    }
    if (key === 'product.instanceId' && !_isUsingProductId) {
      return false;
    }
    return true;
  });
}

export function isUsingExternalId(identifierFields) {
  return identifierFields?.some(
    ({ bottlebooksFieldName }) =>
      bottlebooksFieldName === 'product.productExternalId'
  );
}
function isUsingProductId(identifierFields) {
  return identifierFields?.some(
    ({ bottlebooksFieldName }) => bottlebooksFieldName === 'product.instanceId'
  );
}
